import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button } from 'antd'
import ContentHeader from './ContentHeader'
import { useHormonalAutoimmune, useI18n, useSurvey } from 'contexts/AuthContext'
import CareSelectButton from 'components/CareSelectButton/index'
import { useMetadataOptions, useStep4Location } from 'hooks/careHooks'
import { updateUserPromise } from 'apis/FitOnCareAPI'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { setBrazeProfile } from 'utils/brazeInit'
import _ from 'lodash'
import CareInput from 'components/CareInput/index'
import { isMobile } from 'utils/basic'
import { getLocalLanguage } from 'utils/authLocalStorage'
import { AuthContext } from 'contexts/AuthContext'
const HormonalAutoImmune = (props) => {
  const { sku } = props
  const { i18n } = useI18n()
  const { hormonalAutoimmune, setHormonalAutoimmune } = useHormonalAutoimmune()
  const { survey } = useSurvey()
  const { diseaseHelpOptions } = useMetadataOptions()
  const { getNextScreen } = useStep4Location({ sku })
  const [availableOptions, setAvailableOptions] = useState([])
  const authContext = useContext(AuthContext)
  useEffect(() => {
    logAmplitudeEvent('Screen View: Onboarding - Condition Secondary', {
      sku: sku,
      language: getLocalLanguage(),
    })
  }, [sku])

  useEffect(() => {
    if (survey && diseaseHelpOptions) {
      const _options = _.filter(
        diseaseHelpOptions,
        (item) => item.primaryId === survey.id
      )
      setAvailableOptions(_options)
    }
  }, [survey, diseaseHelpOptions])

  const onSubmit = async (item) => {
    logAmplitudeEvent('Click: Onboarding - Condition Secondary', {
      Condition:
        item.name === 'Other' ? `Other - ${item.otherText}` : item.name,
      language: getLocalLanguage(),
      sku: sku,
    })
    switch (sku) {
      case 'rd':
        updateUserPromise(
          {
            skuCondition: {
              skuSecondary: [item.id.toString()],
              ...(item.otherText && { skuSecondaryOther: [item.otherText] }),
              sku,
            },
          },
          authContext
        )
        break
      default:
        break
    }
    setTimeout(() => {
      setBrazeProfile({
        conditionPrimary: `${survey.name}: ${
          item.otherText ? `${item.name} - ${item.otherText}` : item.name
        }`,
      })
      getNextScreen({
        survey: survey,
        hormonalAutoimmune: item,
      }).then((screenKey) => {
        props.setCurrentKey(screenKey)
      })
    }, 100)
  }

  const isNextButtonEnable = useMemo(() => {
    return (
      !_.isEmpty(hormonalAutoimmune) &&
      (hormonalAutoimmune.name !== 'Other' ||
        !_.isEmpty(hormonalAutoimmune.otherText))
    )
  }, [hormonalAutoimmune])

  return (
    <div className='info-sec'>
      <ContentHeader {...props} />
      <div className='info-content'>
        <div className='title'>
          {i18n(
            `Which {0} could we help you with?`,
            survey?.name?.toLowerCase() || ''
          )}
        </div>
        <div className='subtitle' style={{ marginBottom: '32px' }}>
          {i18n('Select one option from the list below')}
        </div>
        {availableOptions.map((item, index) => (
          <CareSelectButton
            key={index}
            {...{
              selected: hormonalAutoimmune.id === item.id,
              setSelected: (value) => {
                setHormonalAutoimmune({
                  ...item,
                })
              },
              text: item.name,
              className: 'm-b-12 left-align',
            }}
          />
        ))}
        {hormonalAutoimmune.name === 'Other' && (
          <CareInput
            {...{
              inputValue: hormonalAutoimmune.otherText || '',
              setInputValue: (value) => {
                const regex = /^[a-zA-Z0-9\s]*$/
                if (regex.test(value)) {
                  setHormonalAutoimmune({
                    ...hormonalAutoimmune,
                    otherText: value,
                  })
                }
              },
              placeholder: i18n('Please specify'),
              focus: hormonalAutoimmune.name === 'Other',
              maxLength: 50,
              className: 'input-sec-padding',
            }}
          />
        )}
        <Button
          className='btn-primary full-width-btn'
          style={isMobile() ? { width: '100%' } : {}}
          onClick={() => {
            onSubmit({ ...hormonalAutoimmune })
          }}
          disabled={!isNextButtonEnable}
        >
          {i18n('Next')}
        </Button>
      </div>
    </div>
  )
}

export default HormonalAutoImmune
